import { GridColumn } from "@progress/kendo-react-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { Button } from "@progress/kendo-react-buttons";
import { Window } from '@progress/kendo-react-dialogs';
import { Popup } from '@progress/kendo-react-popup';
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { TextBox } from "@progress/kendo-react-inputs";

import { protectedResources } from '../../authConfig';
import BaseGrid from '../../components/KendoGrid/BaseGrid';
import { AppUserContext } from "../../components/PvsContextProvider";
import { useContext, useState } from "react";
import { getReportURL } from "../../utils/reportUtil";
import { useFetchWithMsal } from "../../hooks/useFetchWithMsal";
import { LoadPage } from "../../components/LoadPage";
import { useNotificationAPI } from "../../components/NotificationProvider";
import { DateRangeFilter } from "../../components/KendoGrid/DateRangeFilter";

const pageTitle = 'Legacy Report List';
const LegacyReportList = () => {
    const appUserContext = useContext(AppUserContext);
    const notifcations = useNotificationAPI();
    const { isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });

    const [sendReport, setSendReport] = useState(undefined as any | undefined);
    const [sendEmailToAddress, setSendEmailToAddress] = useState("");

    const recentEntriesFirstSort = [{
        field: "Id",
        dir: "desc"
    } as SortDescriptor];

    const DateCell = (report: any) => {
        var date = new Date(report.dataItem.createdOn);
        return <td>
            {date.toLocaleDateString()}
        </td>;
    }

    const EmailCell = (report: any) => {
        var emails = report.dataItem.legacyContacts;
        return <td>
            {emails.length > 0 ?
                emails[0].email :
                'No Email'}
        </td>;
    }

    const sendEmail = () => {
        if (sendEmailToAddress) {
            execute("POST", protectedResources.apiLegacyReport.endpoint + "SendLegacyReport", { LegacyReportId: sendReport.id, EmailAddress: sendEmailToAddress }).then((data: any) => {
                if (data?.notifications && !data.notifications.hasErrors) {
                    notifcations.addNotification('Legacy Report sent for ID: ' + sendReport.id + ' to ' + sendEmailToAddress, pageTitle, 'success');
                    setSendReport(undefined);
                }
            })
        } else {
            notifcations.addNotification('You must specify an email address if not sending the report to a lab.', pageTitle, 'info');
        }
    }

    const openReportTab = (reportId: any) => {
        const reportURLFunction = (reportUrl: string) => {
            window.open(reportUrl);
        };
        const blobIsEmptyOrUndefined = () => {
            if (appUserContext.adminView) {
                notifcations.addNotification("There was an error opening the report for this kit. Please contact IT to resolve this issue. ReportID: " + reportId, pageTitle, "info");
            } else {
                notifcations.addNotification("There was an error opening the report for this kit. Please contact STATS to resolve this issue. ReportID: " + reportId, pageTitle, "info");
            }
        };

        getReportURL(execute, protectedResources.apiLegacyReport.endpoint + "GetDocumentByLegacyReportId?Id=" + reportId, reportURLFunction, blobIsEmptyOrUndefined);
    }

    const menuSelect = (event: any) => {
        if (event.item.text === "View Report") {
            openReportTab(event.item.data.id);
        } else if (event.item.text === "Email Report") {
            setSendReport(event.item.data);
        }

        setReportOption(undefined);
    }

    const [menuAnchor, setMenuAnchor] = useState<HTMLTableCellElement | undefined>(undefined);
    const [reportOption, setReportOption] = useState(undefined as any | undefined);

    const pdfCell = (props: any) => {
        return (
            <td onClick={(e) => {
                setMenuAnchor(e.currentTarget);
                setReportOption(reportOption === props?.dataItem ? undefined : props?.dataItem);
            }} >
                <span className="k-icon k-font-icon k-i-pdf"></span>
            </td>
        )
    }

    const gridProps = {
        onRowDoubleClick: openReportTab,
        intialSort: recentEntriesFirstSort,
        verb: 'POST',
        pageTitle: 'Legacy Report List',
        endpoint: protectedResources.apiLegacyReport.endpoint + "KendoGridRead",
        excelFunction: (report: any) => {
            const r = { ...report };
            //if (r.reportStatusId !== undefined) {
            //    r.reportStatusId = ReportStatusArray[report.reportStatusId - 1].name;
            //}

            return r;
        }
    }

    return (
        <>
            <Popup
                anchor={menuAnchor}
                anchorAlign={{
                    horizontal: "right",
                    vertical: "bottom"
                }}
                popupAlign={{
                    horizontal: "left",
                    vertical: "bottom"
                }}
                show={menuAnchor !== null}>
                {reportOption !== undefined &&
                    <Menu vertical={true} onSelect={menuSelect}>
                        <MenuItem data={reportOption} text="View Report"></MenuItem>
                        <MenuItem data={reportOption} text="Email Report"></MenuItem>
                    </Menu>}
            </Popup>

            {sendReport &&
                <Window onClose={() => setSendReport(undefined)}>
                    <span>
                        Email Address: <br></br>
                        <TextBox value={sendEmailToAddress} onChange={(data: any) => { setSendEmailToAddress(data.value); }}></TextBox>
                        <br></br>
                        <Button onClick={() => sendEmail()}>Email Report</Button>
                    </span>
                </Window>}
            <LoadPage isLoading={isLoading}>
                <BaseGrid {...gridProps}>
                    <GridColumn width="35px" cell={pdfCell} filterable={false} sortable={false} />
                    <GridColumn field="pipetNumber" title="Pipet Number" filter="text" />
                    <GridColumn field="email" title="Email" filter="text" cell={EmailCell} />
                    <GridColumn field="lotNumber" title="Lot Number" filter="text" />
                    <GridColumn field="createdOn" title="Created On" cell={DateCell} filter="date" filterCell={DateRangeFilter} />
                </BaseGrid>
            </LoadPage>
        </>
    );
}

export default LegacyReportList;